import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, a as assertParamExists, C as COLLECTION_FORMATS, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * PaymentTypesApi - axios parameter creator
 * @export
 */
const PaymentTypesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options = {}) => {
            const localVarPath = `/v1/PaymentTypes/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllByOrder: async (OrderToken, options = {}) => {
            const localVarPath = `/v1/PaymentTypes/GetAllByOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(OrderToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFront: async (options = {}) => {
            const localVarPath = `/v1/PaymentTypes/GetAllFront`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/PaymentTypes/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} request_body
         * @param {boolean} [enrich]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds: async (request_body, enrich, options = {}) => {
            // verify required parameter 'request_body' is not null or undefined
            assertParamExists('getByIds', 'request_body', request_body);
            const localVarPath = `/v1/PaymentTypes/GetByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (enrich !== undefined) {
                localVarQueryParameter['enrich'] = enrich;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(request_body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByShippingType: async (OrderToken, options = {}) => {
            const localVarPath = `/v1/PaymentTypes/GetByShippingType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(OrderToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlineStatuses: async (options = {}) => {
            const localVarPath = `/v1/PaymentTypes/GetOnlineStatuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlineTypes: async (options = {}) => {
            const localVarPath = `/v1/PaymentTypes/GetOnlineTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlineWallets: async (options = {}) => {
            const localVarPath = `/v1/PaymentTypes/GetOnlineWallets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {PaymentTypeToken} [PaymentTypeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (PaymentTypeToken, options = {}) => {
            const localVarPath = `/v1/PaymentTypes/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(PaymentTypeToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth)
         * @param {PaymentTypeLookupRequest} PaymentTypeLookupRequest
         * @param {Array<string>} [X_Lookup_Metadata] Provides which of the \&#39;total\&#39; or \&#39;offset\&#39; metadata are needed in the response. (Optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup: async (PaymentTypeLookupRequest, X_Lookup_Metadata, options = {}) => {
            // verify required parameter 'PaymentTypeLookupRequest' is not null or undefined
            assertParamExists('lookup', 'PaymentTypeLookupRequest', PaymentTypeLookupRequest);
            const localVarPath = `/v1/PaymentTypes/Lookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (X_Lookup_Metadata) {
                let mapped = X_Lookup_Metadata.map(value => (value || ""));
                localVarHeaderParameter['X-Lookup-Metadata'] = mapped.join(COLLECTION_FORMATS["csv"]);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(PaymentTypeLookupRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/PaymentTypes/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {PaymentTypeToken} [PaymentTypeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (PaymentTypeToken, options = {}) => {
            const localVarPath = `/v1/PaymentTypes/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(PaymentTypeToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PaymentTypesApi - functional programming interface
 * @export
 */
const PaymentTypesApiFp = function (configuration) {
    const localVarAxiosParamCreator = PaymentTypesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentTypesApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllByOrder(OrderToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllByOrder(OrderToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentTypesApi.getAllByOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllFront(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllFront(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentTypesApi.getAllFront']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentTypesApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} request_body
         * @param {boolean} [enrich]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByIds(request_body, enrich, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByIds(request_body, enrich, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentTypesApi.getByIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByShippingType(OrderToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByShippingType(OrderToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentTypesApi.getByShippingType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnlineStatuses(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOnlineStatuses(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentTypesApi.getOnlineStatuses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnlineTypes(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOnlineTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentTypesApi.getOnlineTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnlineWallets(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOnlineWallets(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentTypesApi.getOnlineWallets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {PaymentTypeToken} [PaymentTypeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(PaymentTypeToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(PaymentTypeToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentTypesApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth)
         * @param {PaymentTypeLookupRequest} PaymentTypeLookupRequest
         * @param {Array<string>} [X_Lookup_Metadata] Provides which of the \&#39;total\&#39; or \&#39;offset\&#39; metadata are needed in the response. (Optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lookup(PaymentTypeLookupRequest, X_Lookup_Metadata, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lookup(PaymentTypeLookupRequest, X_Lookup_Metadata, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentTypesApi.lookup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentTypesApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {PaymentTypeToken} [PaymentTypeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(PaymentTypeToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(PaymentTypeToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentTypesApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PaymentTypesApi - factory interface
 * @export
 */
const PaymentTypesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PaymentTypesApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options) {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllByOrder(OrderToken, options) {
            return localVarFp.getAllByOrder(OrderToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFront(options) {
            return localVarFp.getAllFront(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} request_body
         * @param {boolean} [enrich]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds(request_body, enrich, options) {
            return localVarFp.getByIds(request_body, enrich, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrderToken} [OrderToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByShippingType(OrderToken, options) {
            return localVarFp.getByShippingType(OrderToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlineStatuses(options) {
            return localVarFp.getOnlineStatuses(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlineTypes(options) {
            return localVarFp.getOnlineTypes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlineWallets(options) {
            return localVarFp.getOnlineWallets(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {PaymentTypeToken} [PaymentTypeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(PaymentTypeToken, options) {
            return localVarFp.insert(PaymentTypeToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth)
         * @param {PaymentTypeLookupRequest} PaymentTypeLookupRequest
         * @param {Array<string>} [X_Lookup_Metadata] Provides which of the \&#39;total\&#39; or \&#39;offset\&#39; metadata are needed in the response. (Optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup(PaymentTypeLookupRequest, X_Lookup_Metadata, options) {
            return localVarFp.lookup(PaymentTypeLookupRequest, X_Lookup_Metadata, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {PaymentTypeToken} [PaymentTypeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(PaymentTypeToken, options) {
            return localVarFp.update(PaymentTypeToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PaymentTypesApi - object-oriented interface
 * @export
 * @class PaymentTypesApi
 * @extends {BaseAPI}
 */
class PaymentTypesApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTypesApi
     */
    getAll(options) {
        return PaymentTypesApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrderToken} [OrderToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTypesApi
     */
    getAllByOrder(OrderToken, options) {
        return PaymentTypesApiFp(this.configuration).getAllByOrder(OrderToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTypesApi
     */
    getAllFront(options) {
        return PaymentTypesApiFp(this.configuration).getAllFront(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTypesApi
     */
    getById(id, options) {
        return PaymentTypesApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} request_body
     * @param {boolean} [enrich]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTypesApi
     */
    getByIds(request_body, enrich, options) {
        return PaymentTypesApiFp(this.configuration).getByIds(request_body, enrich, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrderToken} [OrderToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTypesApi
     */
    getByShippingType(OrderToken, options) {
        return PaymentTypesApiFp(this.configuration).getByShippingType(OrderToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTypesApi
     */
    getOnlineStatuses(options) {
        return PaymentTypesApiFp(this.configuration).getOnlineStatuses(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTypesApi
     */
    getOnlineTypes(options) {
        return PaymentTypesApiFp(this.configuration).getOnlineTypes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTypesApi
     */
    getOnlineWallets(options) {
        return PaymentTypesApiFp(this.configuration).getOnlineWallets(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {PaymentTypeToken} [PaymentTypeToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTypesApi
     */
    insert(PaymentTypeToken, options) {
        return PaymentTypesApiFp(this.configuration).insert(PaymentTypeToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth)
     * @param {PaymentTypeLookupRequest} PaymentTypeLookupRequest
     * @param {Array<string>} [X_Lookup_Metadata] Provides which of the \&#39;total\&#39; or \&#39;offset\&#39; metadata are needed in the response. (Optional)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTypesApi
     */
    lookup(PaymentTypeLookupRequest, X_Lookup_Metadata, options) {
        return PaymentTypesApiFp(this.configuration).lookup(PaymentTypeLookupRequest, X_Lookup_Metadata, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTypesApi
     */
    remove(id, options) {
        return PaymentTypesApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {PaymentTypeToken} [PaymentTypeToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTypesApi
     */
    update(PaymentTypeToken, options) {
        return PaymentTypesApiFp(this.configuration).update(PaymentTypeToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { PaymentTypesApi, PaymentTypesApiAxiosParamCreator, PaymentTypesApiFactory, PaymentTypesApiFp };
//# sourceMappingURL=payment-types-api.js.map
